import validate from "/usr/src/app/content/n3-redirections-service-8b637909-b96b-4092-8440-db1a6e672845/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-redirections-service-8b637909-b96b-4092-8440-db1a6e672845/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}